enum JobType {
  DMSCOMMENT = 'DMSCOMMENT',
  COMMENT = 'NOTE',
  JOB = 'JOB'
}

export default JobType;